import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

const KEY = "alphalane_cookie_consent";

export const CookieBanner = () => {
  const { t } = useT();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const consent = localStorage.getItem(KEY);
    if (!consent) setOpen(true);
  }, []);

  const accept = (kind) => {
    localStorage.setItem(KEY, kind);
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-[60] al-card p-5 shadow-2xl shadow-purple-500/15"
    >
      <div className="flex items-start gap-3">
        <span className="h-9 w-9 rounded-xl al-grad-soft-bg flex items-center justify-center text-[var(--al-purple)] flex-shrink-0">
          <Cookie className="h-4 w-4" />
        </span>
        <div className="flex-1 min-w-0">
          <div className="font-display font-semibold text-[15px]">{t.cookie.title}</div>
          <p className="mt-1.5 text-[13px] text-slate-600 leading-relaxed">{t.cookie.text}</p>
          <div className="mt-3 flex flex-wrap items-center gap-2">
            <button
              onClick={() => accept("all")}
              data-testid="cookie-accept"
              className="al-cta !py-2 !px-4 text-[13px]"
            >
              {t.cookie.accept}
            </button>
            <button
              onClick={() => accept("necessary")}
              data-testid="cookie-decline"
              className="al-cta-ghost !py-2 !px-4 text-[13px]"
            >
              {t.cookie.decline}
            </button>
            <Link to="/datenschutz" className="text-[12px] text-slate-500 hover:text-[var(--al-purple)] underline ml-auto">
              {t.cookie.privacy}
            </Link>
          </div>
        </div>
        <button
          onClick={() => accept("dismissed")}
          aria-label="Close"
          className="text-slate-400 hover:text-slate-700 flex-shrink-0"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
